import React from 'react';

const AboutIcon = (props) => {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' fill='none' {...props}>
      <path
        id='Combined Shape'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28C22.6274 28 28 22.6274 28 16ZM6 16C6 10.4772 10.4772 6 16 6C21.5228 6 26 10.4772 26 16C26 21.5228 21.5228 26 16 26C10.4772 26 6 21.5228 6 16ZM15 22V15C15 14.3549 15.4487 14 16 14C16.5513 14 17 14.3549 17 15V22C17 22.6451 16.5513 23 16 23C15.4487 23 15 22.6451 15 22ZM14.5 11C14.5 11.827 15.173 12.5 16 12.5C16.827 12.5 17.5 11.827 17.5 11C17.5 10.173 16.827 9.5 16 9.5C15.173 9.5 14.5 10.173 14.5 11Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default AboutIcon;
